export default __webpack_public_path__ + "static/media/google_play.84e4ab3a.svg";